var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.28730",
      "conversations-internal-schema": "static-1.13660",
      "head-dlb": "static-1.5330",
      "hs-test-utils": "static-1.8537",
      "hubspot-url-utils": "static-1.4474",
      "HubStyleTokens": "static-2.11985",
      "I18n": "static-7.1715",
      "jasmine-runner": "static-1.6951",
      "quartz": "static-1.7693",
      "react": "static-7.205",
      "reselect": "static-3.18",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.520",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.6656",
      "enviro": "static-4.523",
      "hs-promise-rejection-tracking": "static-1.6078",
      "PortalIdParser": "static-2.458",
      "raven": "static-3.6411",
      "raven-hubspot": "static-1.6718",
      "moment": "static-3.75",
      "customer-data-email": "static-1.18677",
      "cv-backend-services": "static-1.1607",
      "hub-http": "static-1.6704",
      "immutable": "static-2.93",
      "immutable-less": "static-1.5150",
      "quartz-config": "static-1.1471",
      "quartz-core": "static-1.6912",
      "transmute": "static-2.97",
      "HeadJS": "static-2.829",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.8784",
      "framer-motion": "static-1.86",
      "hs-test-utils-bend-plugin": "static-1.3648",
      "msw": "static-1.105",
      "msw-config": "static-1.35",
      "react-redux": "static-7.86",
      "redux": "static-4.86",
      "testing-library": "static-1.167",
      "foundations-theming": "static-1.4988",
      "i18n-data": "static-1.237",
      "metrics-js": "static-1.10135",
      "moment-timezone": "static-5.98",
      "react-utils": "static-2.5677",
      "jasmine": "static-4.4804",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.3381",
      "react-aria": "static-1.79",
      "styled-components": "static-2.106",
      "UIComponents": "static-3.8931",
      "visitor-ui-component-library-icons": "static-1.6467",
      "apollo-dlb": "static-3.98",
      "apollo-link-hub-http": "static-2.5087",
      "apollo-stack-hubspot": "static-3.101",
      "classnames": "static-2.10",
      "cssUtils": "static-1.1121",
      "customer-data-objects": "static-1.8208",
      "customer-data-ui-utilities": "static-1.10330",
      "data-fetching-client": "static-1.10137",
      "FileManagerCore": "static-1.40377",
      "FileManagerLib": "static-1.40518",
      "foundations-assets": "static-1.5388",
      "graphql": "static-1.95",
      "hs-promise-utils": "static-1.6090",
      "hubspot-apollo-client": "static-1.5381",
      "icons": "static-2.708",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.120",
      "react-virtualized": "static-2.114",
      "rpc-client-utils": "static-1.5165",
      "salesImages": "static-1.756",
      "timezone-utils": "static-2.5729",
      "ui-gdpr-components": "static-1.10658",
      "ts-schema": "static-1.4407",
      "hs-locale-management": "static-1.414",
      "hs-lodash": "static-4.45",
      "immer": "static-1.107",
      "opentelemetry-fe-types": "static-1.290",
      "dispatcher": "static-1.150",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.913",
      "hubspotter-http": "static-1.4987",
      "mobile-manifest-mixins": "static-1.612",
      "module-federation": "static-1.42",
      "opentelemetry-fe": "static-1.665",
      "quartz-auth": "static-1.1368",
      "quartz-head": "static-1.1358",
      "quartz-i18n": "static-1.1368",
      "quartz-routing": "static-1.1123",
      "quartz-test": "static-1.1368",
      "quartz-tracking": "static-1.1072",
      "quick-fetch": "static-1.4243",
      "react-rhumb": "static-1.17238",
      "trellis-components": "static-1.3166",
      "ui-fonts": "static-1.1247",
      "usage-tracker-container": "static-1.7811",
      "usage-tracker-core": "static-1.7671",
      "bend-plugin-foundations-components": "static-1.5053",
      "floating-ui": "static-1.70",
      "foundations-theming-specialty": "static-1.2704",
      "hs-story-utils": "static-1.9927",
      "react-create-root-preference": "static-1.111",
      "tanstack-table": "static-1.68",
      "trellis-assets": "static-1.3147",
      "ui-images": "static-2.1282",
      "bender-build-tools": "static-1.3615",
      "bend-plugin-foundations-theming": "static-1.3471",
      "foundations-theming-base": "static-1.3973",
      "stylex": "static-1.48",
      "beacon-keepalive-queue": "static-1.198",
      "bend-plugin-metrics-js": "static-1.112",
      "HubStyle": "static-2.12292",
      "sassPrefix": "static-1.386",
      "inbound-db-properties-service-client": "static-1.4163",
      "property-translator": "static-1.5879",
      "react-dnd-compat": "static-1.5109",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.10064",
      "audio-components": "static-1.6605",
      "breeze-artifacts-sdk": "static-1.1063",
      "ContentUtils": "static-1.69529",
      "copilot-toolkit": "static-1.12193",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.30094",
      "file-manager-components": "static-1.24878",
      "FileManagerImages": "static-1.38029",
      "foundations-components-legacy": "static-1.1809",
      "html-to-image": "static-1.67",
      "immerable": "static-1.4641",
      "react-colorpicker": "static-2.10708",
      "redux-toolkit": "static-1.84",
      "ui-universal-auth": "static-1.9785",
      "urlinator": "static-1.5012",
      "usage-tracker": "static-1.7821",
      "video-components": "static-1.14489",
      "video-data-lib": "static-1.36145",
      "video-embed": "static-1.36979",
      "redux-thunk": "static-2.86",
      "hubspot-apollo-cache": "static-1.840",
      "bend-plugin-chirp-manifest": "static-1.575",
      "chirp-fetch": "static-1.2403",
      "opentelemetry-web": "static-1.25",
      "hub-http-shared-msw-handlers": "static-1.10940",
      "hubspotter-http-shared-msw-handlers": "static-1.10938",
      "usage-tracker-session-replay": "static-1.5507",
      "web-vitals": "static-1.21",
      "base-ui": "static-1.31",
      "react-day-picker": "static-1.17",
      "trellis-theming": "static-1.1515",
      "tanstack-virtual": "static-1.45",
      "stylex-utils": "static-1.182",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.24010",
      "customer-data-objects-ui-components": "static-1.13534",
      "sanitize": "static-1.4971",
      "sanitize-text": "static-1.8656",
      "content-assistance-lib": "static-1.8455",
      "breeze-engine-core": "static-1.1533",
      "cms-field-types": "static-1.5309",
      "content-icons-ui": "static-1.2480",
      "integrations-lib": "static-1.17480",
      "underscore": "static-1.8",
      "breeze-engine-lib": "static-1.2255",
      "magpie-lib": "static-1.5928",
      "magpie-types": "static-1.5388",
      "simple-logging-lib": "static-1.3550",
      "superstore": "static-1.5256",
      "nudge-client-utils": "static-1.3454",
      "poll-commands": "static-1.3976",
      "ui-addon-iframeable": "static-1.9578",
      "video-components-external": "static-1.12487",
      "custom-vendor-connection-lib": "static-1.349",
      "unified-auth-core-lib": "static-1.1581",
      "social-insights-client-types": "static-1.22970",
      "SharedI18nStrings": "static-1.190",
      "outpost": "static-1.4628",
      "amplitude-session-replay-browser": "static-1.60",
      "markdown-it": "static-1.6",
      "atom": "static-1.5570",
      "avatar-components": "static-1.2987",
      "reference-resolvers": "static-1.8683",
      "ui-addon-video-player": "static-1.9122",
      "ui-coaching-tips": "static-1.29607",
      "flux-actions": "static-1.383",
      "frontend-preferences-client": "static-1.8420",
      "integrations-error-boundary-lib": "static-1.14895",
      "integrations-tracking-lib": "static-1.6122",
      "laboratory-lib": "static-3.7645",
      "native-integrations-shared-strings": "static-1.8261",
      "redux-observable": "static-1.81",
      "ReduxMessenger": "static-2.10869",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.11644",
      "ui-shepherd-react": "static-3.10779",
      "ably": "static-2.2",
      "batch-promise": "static-1.2048",
      "breeze-engine-chat-components": "static-1.1233",
      "highlight.js": "static-1.92",
      "pulse": "static-1.1149",
      "idb-keyval": "static-1.57",
      "reactive-lib": "static-1.1219",
      "nudge-custom-function-registry": "static-1.3211",
      "nudge-renderer-utils": "static-1.3530",
      "onboarding-tours": "static-1.17423",
      "whisper-core-api": "static-1.7675",
      "navigation-messaging": "static-1.8543",
      "content-media-composition-data-lib": "static-1.13635",
      "content-media-compositions": "static-2.17642",
      "media-bridge-lib": "static-1.19676",
      "codemirror": "static-5.108",
      "fsm": "static-1.4256",
      "react-codemirror": "static-1.11141",
      "trellis-migration-context": "static-1.77",
      "growth-onboarding-feedback-components": "static-1.7080",
      "universal-page-editor-lib": "static-1.3512",
      "foundations-components-test-utils": "static-1.6267",
      "bend-plugin-pulse": "static-1.652",
      "event-emitter": "static-1.1460",
      "fast-json-patch": "static-1.76",
      "getting-started-shared-tasks": "static-1.19604",
      "growth-data-modal": "static-1.6168",
      "growth-onboarding-confetti": "static-1.3557",
      "growth-onboarding-next-action-utils": "static-1.3025",
      "navigation-components": "static-1.19216",
      "nest": "static-1.735",
      "onboarding-tours-client": "static-1.5638",
      "onboarding-tours-utils": "static-1.1490",
      "ui-shepherd-tracker": "static-1.8160",
      "user-context": "static-1.5553",
      "nav-meta": "static-1.30853",
      "js-cookie": "static-1.18",
      "diff-match-patch": "static-1.7",
      "browser-eslint": "static-2.57",
      "crm-record-cards-client": "static-1.101",
      "crm-record-cards-service-types": "static-1.3874",
      "framework-data-schema-resolvers": "static-1.7392",
      "location-customization-utils-lib": "static-1.10465",
      "onboarding-data-sync-lib": "static-1.2871",
      "growth-onboarding-next-action-components": "static-1.3053",
      "user-context-client": "static-1.5008",
      "getting-started-shared-tasks-store": "static-1.18722",
      "conditional-properties-service-client": "static-1.4126",
      "crm-pipelines-api-client-types": "static-1.4456",
      "fdsr-migration-layer": "static-1.511",
      "framework-builder-read-service-client": "static-1.4348",
      "framework-data-schema-quick-fetch": "static-1.7297",
      "inbound-db-meta-service-client": "static-1.3787",
      "multi-currency-client-types": "static-1.4021",
      "persist-promise": "static-1.4205",
      "InboxConnectUtils": "static-4.15881",
      "meetings-connect-utils-lib": "static-1.8119",
      "onboarding-scopes": "static-1.6952",
      "hub-http-contrib": "static-1.3531",
      "ui-addon-sales-email": "static-1.5701"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.28730",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13660",
      "head-dlb": "/head-dlb/static-1.5330",
      "hs-test-utils": "/hs-test-utils/static-1.8537",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4474",
      "HubStyleTokens": "/HubStyleTokens/static-2.11985",
      "I18n": "/I18n/static-7.1715",
      "jasmine-runner": "/jasmine-runner/static-1.6951",
      "quartz": "/quartz/static-1.7693",
      "react": "/react/static-7.205",
      "reselect": "/reselect/static-3.18",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.520",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6656",
      "enviro": "/enviro/static-4.523",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6078",
      "PortalIdParser": "/PortalIdParser/static-2.458",
      "raven": "/raven/static-3.6411",
      "raven-hubspot": "/raven-hubspot/static-1.6718",
      "moment": "/moment/static-3.75",
      "customer-data-email": "/customer-data-email/static-1.18677",
      "cv-backend-services": "/cv-backend-services/static-1.1607",
      "hub-http": "/hub-http/static-1.6704",
      "immutable": "/immutable/static-2.93",
      "immutable-less": "/immutable-less/static-1.5150",
      "quartz-config": "/quartz-config/static-1.1471",
      "quartz-core": "/quartz-core/static-1.6912",
      "transmute": "/transmute/static-2.97",
      "HeadJS": "/HeadJS/static-2.829",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.8784",
      "framer-motion": "/framer-motion/static-1.86",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3648",
      "msw": "/msw/static-1.105",
      "msw-config": "/msw-config/static-1.35",
      "react-redux": "/react-redux/static-7.86",
      "redux": "/redux/static-4.86",
      "testing-library": "/testing-library/static-1.167",
      "foundations-theming": "/foundations-theming/static-1.4988",
      "i18n-data": "/i18n-data/static-1.237",
      "metrics-js": "/metrics-js/static-1.10135",
      "moment-timezone": "/moment-timezone/static-5.98",
      "react-utils": "/react-utils/static-2.5677",
      "jasmine": "/jasmine/static-4.4804",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.3381",
      "react-aria": "/react-aria/static-1.79",
      "styled-components": "/styled-components/static-2.106",
      "UIComponents": "/UIComponents/static-3.8931",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6467",
      "apollo-dlb": "/apollo-dlb/static-3.98",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5087",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.101",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.1121",
      "customer-data-objects": "/customer-data-objects/static-1.8208",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10330",
      "data-fetching-client": "/data-fetching-client/static-1.10137",
      "FileManagerCore": "/FileManagerCore/static-1.40377",
      "FileManagerLib": "/FileManagerLib/static-1.40518",
      "foundations-assets": "/foundations-assets/static-1.5388",
      "graphql": "/graphql/static-1.95",
      "hs-promise-utils": "/hs-promise-utils/static-1.6090",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5381",
      "icons": "/icons/static-2.708",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.120",
      "react-virtualized": "/react-virtualized/static-2.114",
      "rpc-client-utils": "/rpc-client-utils/static-1.5165",
      "salesImages": "/salesImages/static-1.756",
      "timezone-utils": "/timezone-utils/static-2.5729",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10658",
      "ts-schema": "/ts-schema/static-1.4407",
      "hs-locale-management": "/hs-locale-management/static-1.414",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.107",
      "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.290",
      "dispatcher": "/dispatcher/static-1.150",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.913",
      "hubspotter-http": "/hubspotter-http/static-1.4987",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.612",
      "module-federation": "/module-federation/static-1.42",
      "opentelemetry-fe": "/opentelemetry-fe/static-1.665",
      "quartz-auth": "/quartz-auth/static-1.1368",
      "quartz-head": "/quartz-head/static-1.1358",
      "quartz-i18n": "/quartz-i18n/static-1.1368",
      "quartz-routing": "/quartz-routing/static-1.1123",
      "quartz-test": "/quartz-test/static-1.1368",
      "quartz-tracking": "/quartz-tracking/static-1.1072",
      "quick-fetch": "/quick-fetch/static-1.4243",
      "react-rhumb": "/react-rhumb/static-1.17238",
      "trellis-components": "/trellis-components/static-1.3166",
      "ui-fonts": "/ui-fonts/static-1.1247",
      "usage-tracker-container": "/usage-tracker-container/static-1.7811",
      "usage-tracker-core": "/usage-tracker-core/static-1.7671",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5053",
      "floating-ui": "/floating-ui/static-1.70",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2704",
      "hs-story-utils": "/hs-story-utils/static-1.9927",
      "react-create-root-preference": "/react-create-root-preference/static-1.111",
      "tanstack-table": "/tanstack-table/static-1.68",
      "trellis-assets": "/trellis-assets/static-1.3147",
      "ui-images": "/ui-images/static-2.1282",
      "bender-build-tools": "/bender-build-tools/static-1.3615",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3471",
      "foundations-theming-base": "/foundations-theming-base/static-1.3973",
      "stylex": "/stylex/static-1.48",
      "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.198",
      "bend-plugin-metrics-js": "/bend-plugin-metrics-js/static-1.112",
      "HubStyle": "/HubStyle/static-2.12292",
      "sassPrefix": "/sassPrefix/static-1.386",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4163",
      "property-translator": "/property-translator/static-1.5879",
      "react-dnd-compat": "/react-dnd-compat/static-1.5109",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.10064",
      "audio-components": "/audio-components/static-1.6605",
      "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1063",
      "ContentUtils": "/ContentUtils/static-1.69529",
      "copilot-toolkit": "/copilot-toolkit/static-1.12193",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.30094",
      "file-manager-components": "/file-manager-components/static-1.24878",
      "FileManagerImages": "/FileManagerImages/static-1.38029",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1809",
      "html-to-image": "/html-to-image/static-1.67",
      "immerable": "/immerable/static-1.4641",
      "react-colorpicker": "/react-colorpicker/static-2.10708",
      "redux-toolkit": "/redux-toolkit/static-1.84",
      "ui-universal-auth": "/ui-universal-auth/static-1.9785",
      "urlinator": "/urlinator/static-1.5012",
      "usage-tracker": "/usage-tracker/static-1.7821",
      "video-components": "/video-components/static-1.14489",
      "video-data-lib": "/video-data-lib/static-1.36145",
      "video-embed": "/video-embed/static-1.36979",
      "redux-thunk": "/redux-thunk/static-2.86",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.840",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.575",
      "chirp-fetch": "/chirp-fetch/static-1.2403",
      "opentelemetry-web": "/opentelemetry-web/static-1.25",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10940",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10938",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5507",
      "web-vitals": "/web-vitals/static-1.21",
      "base-ui": "/base-ui/static-1.31",
      "react-day-picker": "/react-day-picker/static-1.17",
      "trellis-theming": "/trellis-theming/static-1.1515",
      "tanstack-virtual": "/tanstack-virtual/static-1.45",
      "stylex-utils": "/stylex-utils/static-1.182",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.24010",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13534",
      "sanitize": "/sanitize/static-1.4971",
      "sanitize-text": "/sanitize-text/static-1.8656",
      "content-assistance-lib": "/content-assistance-lib/static-1.8455",
      "breeze-engine-core": "/breeze-engine-core/static-1.1533",
      "cms-field-types": "/cms-field-types/static-1.5309",
      "content-icons-ui": "/content-icons-ui/static-1.2480",
      "integrations-lib": "/integrations-lib/static-1.17480",
      "underscore": "/underscore/static-1.8",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.2255",
      "magpie-lib": "/magpie-lib/static-1.5928",
      "magpie-types": "/magpie-types/static-1.5388",
      "simple-logging-lib": "/simple-logging-lib/static-1.3550",
      "superstore": "/superstore/static-1.5256",
      "nudge-client-utils": "/nudge-client-utils/static-1.3454",
      "poll-commands": "/poll-commands/static-1.3976",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9578",
      "video-components-external": "/video-components-external/static-1.12487",
      "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.349",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1581",
      "social-insights-client-types": "/social-insights-client-types/static-1.22970",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
      "outpost": "/outpost/static-1.4628",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "markdown-it": "/markdown-it/static-1.6",
      "atom": "/atom/static-1.5570",
      "avatar-components": "/avatar-components/static-1.2987",
      "reference-resolvers": "/reference-resolvers/static-1.8683",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.9122",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29607",
      "flux-actions": "/flux-actions/static-1.383",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8420",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14895",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6122",
      "laboratory-lib": "/laboratory-lib/static-3.7645",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8261",
      "redux-observable": "/redux-observable/static-1.81",
      "ReduxMessenger": "/ReduxMessenger/static-2.10869",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11644",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10779",
      "ably": "/ably/static-2.2",
      "batch-promise": "/batch-promise/static-1.2048",
      "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1233",
      "highlight.js": "/highlight.js/static-1.92",
      "pulse": "/pulse/static-1.1149",
      "idb-keyval": "/idb-keyval/static-1.57",
      "reactive-lib": "/reactive-lib/static-1.1219",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3211",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3530",
      "onboarding-tours": "/onboarding-tours/static-1.17423",
      "whisper-core-api": "/whisper-core-api/static-1.7675",
      "navigation-messaging": "/navigation-messaging/static-1.8543",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13635",
      "content-media-compositions": "/content-media-compositions/static-2.17642",
      "media-bridge-lib": "/media-bridge-lib/static-1.19676",
      "codemirror": "/codemirror/static-5.108",
      "fsm": "/fsm/static-1.4256",
      "react-codemirror": "/react-codemirror/static-1.11141",
      "trellis-migration-context": "/trellis-migration-context/static-1.77",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7080",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3512",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6267",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.652",
      "event-emitter": "/event-emitter/static-1.1460",
      "fast-json-patch": "/fast-json-patch/static-1.76",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19604",
      "growth-data-modal": "/growth-data-modal/static-1.6168",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3557",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3025",
      "navigation-components": "/navigation-components/static-1.19216",
      "nest": "/nest/static-1.735",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.5638",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1490",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8160",
      "user-context": "/user-context/static-1.5553",
      "nav-meta": "/nav-meta/static-1.30853",
      "js-cookie": "/js-cookie/static-1.18",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "browser-eslint": "/browser-eslint/static-2.57",
      "crm-record-cards-client": "/crm-record-cards-client/static-1.101",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3874",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7392",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10465",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2871",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3053",
      "user-context-client": "/user-context-client/static-1.5008",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18722",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4126",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4456",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.511",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4348",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7297",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3787",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.4021",
      "persist-promise": "/persist-promise/static-1.4205",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.15881",
      "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8119",
      "onboarding-scopes": "/onboarding-scopes/static-1.6952",
      "hub-http-contrib": "/hub-http-contrib/static-1.3531",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5701"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.28730",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};